<div [ngStyle]="{'background-color': dealBackgroundColor}">

    <div *ngIf="campaignData?.status=='ACCEPTED'">
        <h3 class="text-center"> {{resource.Campaign_Approved_Accepted}}
            {{moment(this.campaignData.startDate).format('MM-DD-YY')}}</h3>
    </div>
    <div *ngIf="campaignData?.status == 'Expired'">
        <h3 class="text-center"> {{resource.Campaign_Expired}}</h3>
    </div>
    <div *ngIf="campaignData?.status=='PUBLISHED'">
        <div *ngIf="(campaignData?.status === 'PUBLISHED') && (moment(campaignData?.startDate).isAfter(moment()))">
            <h3 class="text-center">{{resource.Campaign_published_startDate_greater_CurrentDate}}
                {{moment(this.campaignData.startDate).format('MM-DD-YY')}} </h3>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 no-record" *ngIf="!locationMatch && !invalidPrivateCampaign">
            <div class="row">
                <div class="text-center">
                    <h3>{{resource.campaign_is_not_available}}</h3>
                    <p>{{resource.no_record_found_criteria}}</p>
                    <img src="../../../assets/img/data-not-found.png">
                </div>
            </div>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 no-record" *ngIf="invalidPrivateCampaign">
            <div class="row">
                <div class="text-center">
                    <h3>{{resource.inavlid_private_campaign}}</h3>
                    <p>{{resource.contact_store_manager}}</p>
                    <img src="../../../assets/img/data-not-found.png">
                </div>
            </div>
        </div>
        <section class="deals-details-area pb-3 pt-3" *ngIf="locationMatch && !invalidPrivateCampaign">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <div
                            class="page-toolbar container px-3 py-2 d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <button type="button" class="btn btn-deals featured-back-btn" (click)="onClickBacktoDeal()">
                                <!-- <i class="bx bx-list-ul" style="position:relative; top:1px;"></i> -->
                                <!-- Promotions -->
                                <i class="fa-solid fa-arrow-left ms-1" style="position:relative; top:1px;"></i>
                                &nbsp; Back To List

                            </button>
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-12">
                        <div>
                            <div class="deals-details-image-slides">
                                <owl-carousel-o [options]="dealsDetailsImageSlides">
                                    <ng-template carouselSlide
                                        *ngFor="let image of (campaignData?.applicableOn  == 'PRODUCT' ? displayedImages : [campaignData.campaignImage])">
                                        <div class="article-image mt-2">
                                            <img class="mt-2" [src]="image" alt="image">
                                        </div>
                                    </ng-template>
                                </owl-carousel-o>
                            </div>
                            <div class="product-offer-row" *ngIf="campaignData?.applicableOn  == 'PRODUCT'">
                                <span class="title">Product On Offer:</span>
                                <div class="product-list">
                                    <span *ngFor="let product of matchingProducts" class="product-name"
                                        [class.active]="selectedProductId === product._id"
                                        (click)="onProductClick(product)">
                                        {{ product.name }}
                                    </span>
                                </div>
                            </div>
                            <div class="deals-details-content">
                                <div class="deals-details-content-text">


                                    <div class="col-xl-8  col-lg-8  col-md-8"
                                        *ngIf="campaignData?.applicableOn  == 'INVOICE'">
                                        <aside class="widget-area">
                                            <div class="widget widget_deals_sidebar price">

                                                <div class="card-body price">
                                                    <h1 style="text-align: left;">{{offerTypeTitle}}</h1>
                                                    <!-- Header -->
                                                    <div class="row g-3 align-items-end mb-2 border-bottom pb-1">
                                                        <div class="col-12 col-md-4" style="text-align: left;">
                                                            <label>Purchase Amount</label></div>

                                                        <div class="col-12 col-md-4" style="text-align: right;">
                                                            <label>Discount</label></div>
                                                    </div>

                                                    <!-- Values -->
                                                    <div *ngFor="let slab of campaignData.invoiceAmountSlab; let i = index"
                                                        class="row">
                                                        <div class="col-12 col-md-4 " style="text-align: left;">
                                                            {{ccySymbol}} {{ slab.minAmount }} {{'-'}} {{ccySymbol}} {{
                                                            slab.maxAmount }}
                                                        </div>


                                                        <div class="col-12 col-md-4 slab-discount"
                                                            style="text-align: right;">
                                                            <span *ngIf="offerType === 'FLAT'"
                                                                class="slab-discount-text">
                                                                {{ ccySymbol }} {{ slab.discount }}
                                                            </span>

                                                            <span
                                                                *ngIf="offerType === 'DISCOUNT' || offerType === 'PERCENTAGE'"
                                                                class="slab-discount-text">
                                                                {{ slab.discount }}%
                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </aside>
                                    </div>



                                    <h3>{{campaignName}}</h3>
                                    <p>{{offerDescription}}</p>
                                    <div class="rating row d-flex align-items-center">
                                        <div>
                                            <span><b>{{resource.valid_on}} : </b></span>
                                            <span *ngIf="validDays?.length >= 7">
                                                <span> {{resource.everyday}}</span>
                                            </span>
                                            <span *ngIf="validDays?.length < 7">
                                                <span *ngIf="validDays.includes(7)"> Sun</span>
                                                <span *ngIf="validDays.includes(1)"> Mon</span>
                                                <span *ngIf="validDays.includes(2)"> Tue</span>
                                                <span *ngIf="validDays.includes(3)"> Wed</span>
                                                <span *ngIf="validDays.includes(4)"> Thu</span>
                                                <span *ngIf="validDays.includes(5)"> Fri</span>
                                                <span *ngIf="validDays.includes(6)"> Sat</span>
                                            </span>
                                        </div>
                                    </div>
                                    <div><span><b>Start on: </b> {{ campaignData?.startDate | date: 'yyyy-MM-dd' }}
                                        </span>
                                    </div>
                                    <div><span><b>Expires on: </b> {{ endDate | date:'yyyy-MM-dd' }}</span></div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-2">
                                        <ul class="d-flex align-items-center justify-content-center">
                                            <li class="location" data-tooltip="Coupon Type">
                                                <i class="bx bxs-purchase-tag"></i>
                                                <span>{{couponTypeName}}</span>
                                                {{couponTypeName == 'Frequent' ? 'Max Coupon Usage : ' +
                                                campaignData?.couponUsage : ''}}
                                            </li>

                                            <li class="location" data-tooltip="Store Location">
                                                <i class="bx bx-map"></i>
                                                <span>{{location}}</span>
                                            </li>
                                        </ul>

                                        <!-- <ul class="d-flex align-items-center justify-content-center">
  <li class="location" data-tooltip="Coupon Type">
    <i class="bx bxs-purchase-tag"></i>
    <span>{{couponTypeName}}</span>
    {{couponTypeName == 'Frequent' ? 'Max Coupon Usage : ' + campaignData?.couponUsage : ''}}
  </li>

  <li class="location" data-tooltip="Store Location">
    <i class="bx bx-map"></i>
    <span>{{location}}</span>
  </li>
</ul> -->

                                        <!-- <ul class="d-flex align-items-center justify-content-center">
                                        <li class="location">
                                            <i class="bx bxs-purchase-tag"></i>
                                            <span>{{couponTypeName}}</span>
                                            {{couponTypeName == 'Frequent' ? 'Max Coupon Usage : ' +
                                            campaignData?.couponUsage :
                                            ''}}
                                        </li>
                                        <li class="location">
                                            <i class="bx bx-map"></i>
                                            <span>{{resource.location}}</span>
                                            {{location}}
                                        </li>
                                    </ul> -->
                                    </div>
                                    <div class="col-sm-6 text-center products-share mt-2"
                                        *ngIf="!campaignData?.isPrivate">
                                        <ul class="social">
                                            <li><span>Share:</span></li>

                                            <li><a href="https://www.facebook.com/sharer.php?u={{encodeQrCodeValue}}"
                                                    title="facebook" class="facebook" target="_blank"><i
                                                        class='bx bxl-facebook'></i></a>
                                            </li>
                                            <li><a href="https://twitter.com/intent/tweet?text={{encodeQrCodeValue}}"
                                                    title="twitter" class="twitter" target="_blank"><i
                                                        class='bx bxl-twitter'></i></a>
                                            </li>
                                            <li><a href="https://www.linkedin.com/sharing/share-offsite/?url={{encodeQrCodeValue}}"
                                                    title="linkedin" class="linkedin" target="_blank"><i
                                                        class='bx bxl-linkedin'></i></a>
                                            </li>
                                            <li><a href="https://web.whatsapp.com/send?text={{encodeQrCodeValue}}"
                                                    title="whatsapp" class="whatsapp" target="_blank"><i
                                                        class='bx bxl-whatsapp'></i></a>
                                            </li>
                                            <!-- <li><a href="https://www.linkedin.com/shareArticle?mini=true&url={{encodeQrCodeValue}}"
                                            title="instagram" class="instagram" target="_blank"><i
                                                class='bx bxl-instagram'></i></a></li> -->


                                            <li (click)="onClickCopyURL()"><a href="javascript:void(0)" title="copy"
                                                    class="copy"><i class='bx bx-copy-alt'></i></a></li>

                                            <li (click)="onClickDownloadQrCode()"><a href="javascript:void(0)"
                                                    title="download" class="download"><i class='bx bx-download'></i></a>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                            </div>

                            <div class="row deals-details-image-slides" *ngIf="campaignData?.offerType == 'BUYGET'">
                                <div class="col-xl-6 col-lg-6 col-md-12">
                                    <h3 class="text-center">Buy {{campaignData?.mainProductCount}}</h3>
                                    <owl-carousel-o [options]="dealsDetailsImageSlides">
                                        <ng-template carouselSlide *ngFor="let product of buyGetProductBox;">
                                            <div class="single-deals-box">
                                                <div class="deals-image">
                                                    <a href="javascript:void(0)">
                                                        <img class="mt-2"
                                                            [src]="product.image ?? 'assets/img/no-image.png'"
                                                            alt="image">
                                                    </a>
                                                    <a href="javascript:void(0)"
                                                        class="bookmark-save">{{product.number}}</a>
                                                </div>
                                                <div class="deals-content text-center">
                                                    <h3>{{product.title}}</h3>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </owl-carousel-o>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-12">
                                    <h3 class="text-center">Get {{campaignData?.freeProductCount}}</h3>
                                    <owl-carousel-o [options]="dealsDetailsImageSlides">
                                        <ng-template carouselSlide *ngFor="let product of buyGetFreeProductBox;">
                                            <div class="single-deals-box">
                                                <div class="deals-image">
                                                    <a href="javascript:void(0)">
                                                        <img class="mt-2"
                                                            [src]="product.image ?? 'assets/img/no-image.png'"
                                                            alt="image">
                                                    </a>
                                                    <a href="javascript:void(0)"
                                                        class="bookmark-save">{{product.number}}</a>
                                                </div>
                                                <div class="deals-content text-center">
                                                    <h3>{{product.title}}</h3>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </owl-carousel-o>
                                </div>
                            </div>
                            <div class="deals-details-review-comments" style="display: none;">
                                <div class="user-review">
                                    <img src="assets/img/user5.jpg" alt="image">
                                    <div class="review-rating">
                                        <div class="review-stars">
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                        </div>
                                        <span class="d-inline-block">James Anderson</span>
                                    </div>
                                    <span class="d-block sub-comment">Excellent</span>
                                    <p>Very well built theme, couldn't be happier with it. Can't wait for future updates
                                        to
                                        see
                                        what
                                        else they add in.</p>
                                </div>
                                <div class="user-review">
                                    <img src="assets/img/user2.jpg" alt="image">
                                    <div class="review-rating">
                                        <div class="review-stars">
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star"></i>
                                            <i class="bx bxs-star"></i>
                                        </div>
                                        <span class="d-inline-block">Sarah Taylor</span>
                                    </div>
                                    <span class="d-block sub-comment">Video Quality!</span>
                                    <p>Was really easy to implement and they quickly answer my additional questions!</p>
                                </div>
                                <div class="user-review">
                                    <img src="assets/img/user3.jpg" alt="image">
                                    <div class="review-rating">
                                        <div class="review-stars">
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                        </div>
                                        <span class="d-inline-block">David Warner</span>
                                    </div>
                                    <span class="d-block sub-comment">Perfect Coding!</span>
                                    <p>Stunning design, very dedicated crew who welcome new ideas suggested by
                                        customers,
                                        nice
                                        support.</p>
                                </div>
                                <div class="user-review">
                                    <img src="assets/img/user4.jpg" alt="image">
                                    <div class="review-rating">
                                        <div class="review-stars">
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star checked"></i>
                                            <i class="bx bxs-star"></i>
                                        </div>
                                        <span class="d-inline-block">King Kong</span>
                                    </div>
                                    <span class="d-block sub-comment">Perfect Video!</span>
                                    <p>Stunning design, very dedicated crew who welcome new ideas suggested by
                                        customers,
                                        nice
                                        support.</p>
                                </div>
                            </div>
                            <div class="deals-details-review-form" style="display: none;">
                                <h3>Add a review</h3>
                                <p class="comment-notes">Your email address will not be published. Required fields are
                                    marked
                                    <span>*</span>
                                </p>
                                <form>
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12">
                                            <div class="rating">
                                                <input type="radio" id="star5" name="rating" value="5"><label
                                                    for="star5"></label>
                                                <input type="radio" id="star4" name="rating" value="4"><label
                                                    for="star4"></label>
                                                <input type="radio" id="star3" name="rating" value="3"><label
                                                    for="star3"></label>
                                                <input type="radio" id="star2" name="rating" value="2"><label
                                                    for="star2"></label>
                                                <input type="radio" id="star1" name="rating" value="1"><label
                                                    for="star1"></label>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="Name *">
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <div class="form-group">
                                                <input type="email" class="form-control" placeholder="Email *">
                                            </div>
                                        </div>
                                        <div class="col-lg-12 col-md-12">
                                            <div class="form-group">
                                                <textarea placeholder="Your review" class="form-control" cols="30"
                                                    rows="6" spellcheck="false"></textarea>
                                            </div>
                                        </div>
                                        <div class="col-lg-12 col-md-12">
                                            <p class="comment-form-cookies-consent">
                                                <input type="checkbox" id="test1">
                                                <label for="test1">Save my name, email, and website in this browser for
                                                    the
                                                    next
                                                    time I comment.</label>
                                            </p>
                                        </div>
                                        <div class="col-lg-12 col-md-12">
                                            <button type="submit">Submit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-12 ">
                            <aside class="mt-2 mb-2 d-flex align-items-center">

                                <span *ngIf="campaignData?.buyOn?.length" class="me-2">
                                    Buy On:
                                </span>

                                <ul class="social d-flex align-items-center mb-0">
                                    <!-- <li *ngFor="let buyon of getSortedBuyOn(campaignData.buyOn)" class="mx-2"> -->
                                    <li *ngFor="let buyon of getSortedBuyOn(campaignData.buyOn); let i = index"
                                        class="mx-2">
                                        <a *ngIf="buyon.buyOnName === 'Shopify' && buyon.buyOnUrl"
                                            [href]="buyon.buyOnUrl" matTooltip="Buy on Shopify" target="_blank"
                                            rel="noopener" class="market-place">
                                            <img [src]="company_logo || 'assets/img/shopify-logo.png'" alt="Shopify"
                                                class="buyon-circle">
                                        </a>
                                        <a *ngIf="buyon.buyOnName === 'Woocommerce' && buyon.buyOnUrl"
                                            [href]="buyon.buyOnUrl" matTooltip="Buy on Woocommerce" target="_blank"
                                            rel="noopener" class="market-place">
                                            <img src="assets/img/woo.jpg" alt="Woocommerce"
                                                class="buyon-circle woocommerce-logo">
                                        </a>
                                    </li>
                                </ul>

                            </aside>
                        </div>

                        <div class="col-xl-4  col-lg-4  col-md-12">
                            <!-- <aside class="widget-area-mobile"> -->
                            <!-- Mobile -->
                            <aside class="widget-area-mobile d-block d-lg-none">
                                <div class="widget widget_deals_sidebar text-center">
                                    <div class="price" *ngIf="campaignData?.applicableOn  == 'INVOICE'">
                                        <h6 class="text-center">Min Purchase Before Tax</h6>
                                        <span class="new-price">
                                            <span>{{ccySymbol}}</span> {{campaignData?.invoiceAmountSlab |
                                            amountFormat}}
                                        </span>
                                    </div>
                                    <div class="price"
                                        *ngIf="campaignData?.applicableOn  == 'PRODUCT' && campaignData?.regularPrice > 0 && campaignData?.isDisplayProductPrice">
                                        <span class="new-price"
                                            *ngIf="campaignData?.offerType == 'BUYGET'"><span>{{ccySymbol}}</span>
                                            <span>{{campaignData?.regularPrice | amountFormat}}</span></span>
                                        <span class="new-price"
                                            *ngIf="campaignData?.offerType != 'BUYGET'"><span>{{ccySymbol}}</span>
                                            <span>{{campaignData?.offerPrice | amountFormat}}</span></span>
                                        <span class="old-price price-span" *ngIf="campaignData?.offerType != 'BUYGET'">
                                            <span>{{ccySymbol}}</span>
                                            <span>{{campaignData?.regularPrice |amountFormat}}</span></span>
                                    </div>
                                    <div class="buy-now-btn" *ngIf="campaignData?.status != 'Expired'">
                                        <div class="row">

                                            <button type="button" *ngIf="campaignData?.isCartItem"
                                                class="btn-block btn-sm default-btn"
                                                (click)="onAddToCart(campaignData)">
                                                <i class='bx bxs-cart-add'></i>
                                            </button>
                                        </div>
                                        <br>
                                        <!-- <div class="row">
                                            <h3 *ngIf="applicableOn == 'INVOICE'">{{offerTypeTitle2}}</h3>
                                        </div> -->
                                        <div class="row">
                                            <button type="button" (click)="onClickClaimNow()"
                                                class="btn-block btn-sm default-btn"
                                                [disabled]="popup">{{resource.claim_now}}</button>
                                            <!-- <span><i class='bx bx-cart bx-flashing'></i> 247+ bought</span> -->
                                        </div>
                                    </div>

                                    <div class="buy-now-btn" *ngIf="campaignData?.status == 'Expired'">
                                        <h1>{{resource.expired}}</h1>
                                    </div>
                                    <ul class="deals-value"
                                        *ngIf="campaignData?.offerType != 'BUYGET' && campaignData?.isDisplayProductPrice">
                                        <li>{{resource.price}}
                                            <span class="price-span">
                                                <span>{{ccySymbol}}</span>
                                                <span>{{campaignData?.regularPrice | amountFormat}}</span>
                                            </span>
                                        </li>
                                        <li>{{resource.discount}}
                                            <span class="price-span">
                                                <span>{{discount}}</span>
                                            </span>
                                        </li>
                                        <li>{{resource.offer_price}}
                                            <span class="price-span">
                                                <span>{{ccySymbol}}</span>
                                                <span>{{savePrice | amountFormat}}</span>
                                            </span>
                                        </li>
                                    </ul>
                                    <div class="offer-timer">
                                        <p *ngIf="campaignData?.isRequiredTime">{{resource.time_valid}}
                                            {{campaignData?.startTime}} to {{campaignData?.endTime}}</p>
                                        <p>{{resource.time_left_limited_offer}}</p>
                                        <div id="timer" class="d-flex justify-content-center">
                                            <div id="days"
                                                class="align-items-center flex-column d-flex justify-content-center">
                                                {{days}} <span>{{resource.days}}</span></div>
                                            <div id="hours"
                                                class="align-items-center flex-column d-flex justify-content-center">
                                                {{hours}} <span>{{resource.hours}}</span></div>
                                            <div id="minutes"
                                                class="align-items-center flex-column d-flex justify-content-center">
                                                {{minutes}} <span>{{resource.minutes}}</span></div>
                                            <div id="seconds"
                                                class="align-items-center flex-column d-flex justify-content-center">
                                                {{seconds}} <span>{{resource.seconds}}</span></div>
                                        </div>
                                        <br>
                                    </div>
                                </div>
                                <div class="widget widget_about_store"
                                    style="max-height: 600px; overflow-y: auto; padding-top: 0 !important;"
                                    *ngIf="stores.length">
                                    <h3
                                        style="font-size: 20px; background-color: white; position: sticky; top: 0; padding-top: 20px; text-align: center;">
                                        {{resource.retail_stores}}</h3>
                                    <!-- <div *ngFor="let store of stores; trackBy: trackByStore"
     class="row store-mobile"> -->
                                    <div *ngFor="let store of stores; let i = index; trackBy: trackByStore"
                                        class="row store-mobile">
                                        <!--  -->
                                        <div class="col-3" style="text-align: center;">
                                            <i class='bx bxs-store' style="font-size: 72px; color: #a2a1a1;"></i>
                                            <p style="font-size: 12px; font-weight: 600;">
                                                {{ store.displayIndex }} </p>
                                            <!-- <p style="font-size: 12px;">{{store.distance.toFixed(0)}} km</p> -->
                                            <!-- <p style="font-size: 12px;" *ngIf="store?.distance !== null && store?.distance !== undefined">
                                        {{ (+store.distance) | number:'1.0-0' }} km</p> -->
                                        </div>
                                        <div class="col-9"
                                            style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                            <p style="font-size: 16px; color: black; font-weight: 600; margin: 0;">
                                                {{store.name}}
                                            </p>
                                            <p style="margin: 0;"><i class="bx bx-map"></i>
                                                <span>{{store.address}}</span>
                                            </p>
                                            <p style="margin: 0;">PinCode - {{store.postalCode}}</p>
                                            <div class="row" style="margin: 0; color: #666666;">
                                                <div class="col-5"
                                                    style="padding: 0; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                                    <i class="bx bx-user"></i> <span>{{store.primaryContact}} </span>
                                                </div>
                                                <div class="col-1" style="padding: 0;"></div>
                                                <div class="col-6"
                                                    style="padding: 0; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                                    <i class="bx bx-phone-call"></i> <span> {{store.telephone}} </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </aside>
                        </div>
                        <div>
                            <div class="deals-details-desc">
                                <h3 class="toggle-header" (click)="toggleTerms()">
                                    <span *ngIf="!isTermsExpanded" class="toggle-icon">+</span>
                                    <span *ngIf="isTermsExpanded" class="toggle-icon">-</span>
                                    {{ resource.term_conditions }}
                                </h3>
                                <p *ngIf="isTermsExpanded" style="white-space: pre-wrap;"
                                    [innerHTML]="campaignData?.termsCondition"></p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4  col-lg-4  col-md-12">
                        <aside class="widget-area">
                            <div class="widget widget_deals_sidebar">

                                <div class="price"
                                    *ngIf="campaignData?.applicableOn  == 'PRODUCT' && campaignData?.regularPrice > 0 && campaignData?.isDisplayProductPrice">
                                    <span class="new-price"
                                        *ngIf="campaignData?.offerType == 'BUYGET'"><span>{{ccySymbol}}</span>
                                        <span>{{campaignData?.regularPrice | amountFormat}}</span></span>
                                    <span class="new-price"
                                        *ngIf="campaignData?.offerType != 'BUYGET'"><span>{{ccySymbol}}</span>
                                        <span>{{campaignData?.offerPrice | amountFormat}}</span></span>
                                    <span class="old-price price-span" *ngIf="campaignData?.offerType != 'BUYGET'">
                                        <span>{{ccySymbol}}</span>
                                        <span>{{campaignData?.regularPrice |amountFormat}}</span></span>
                                </div>

                                <div class="buy-now-btn" *ngIf="campaignData?.status != 'Expired'">

                                    <!-- <div class="row">
                                        <h3 *ngIf="applicableOn == 'INVOICE'">{{offerTypeTitle2}}</h3>
                                     </div> -->
                                    <div class="row">
                                        <button type="button" *ngIf="campaignData?.isCartItem"
                                            class="btn-block btn-sm default-btn" (click)="onAddToCart(campaignData)">
                                            <i class='bx bxs-cart-add'></i>
                                        </button>
                                    </div>
                                    <br>

                                    <div class="row">
                                        <button type="button" (click)="onClickClaimNow()"
                                            class="btn-block btn-sm default-btn"
                                            [disabled]="popup">{{resource.claim_now}}</button>
                                    </div>


                                    <!-- <span><i class='bx bx-cart bx-flashing'></i> 247+ bought</span> -->
                                </div>
                                <p *ngIf="noOfCoupons <= 20">{{noOfCoupons}}</p>
                                <div class="buy-now-btn" *ngIf="campaignData?.status == 'Expired'">
                                    <h1>{{resource.expired}}</h1>
                                </div>
                                <ul class="deals-value"
                                    *ngIf="campaignData?.offerType != 'BUYGET' && campaignData?.isDisplayProductPrice">
                                    <li>{{resource.price}}
                                        <span class="price-span">
                                            <span>{{ccySymbol}}</span>
                                            <span>{{campaignData?.regularPrice | amountFormat}}</span>
                                        </span>
                                    </li>
                                    <li>{{resource.discount}}
                                        <span class="price-span">
                                            <span>{{discount}}</span>
                                        </span>
                                    </li>
                                    <li>{{resource.offer_price}}
                                        <span class="price-span">
                                            <span>{{ccySymbol}}</span>
                                            <span>{{savePrice | amountFormat}}</span>
                                        </span>
                                    </li>
                                </ul>
                                <div class="offer-timer">
                                    <p *ngIf="campaignData?.isRequiredTime">{{resource.time_valid}}
                                        {{campaignData?.startTime}} to {{campaignData?.endTime}}</p>
                                    <p>{{resource.time_left_limited_offer}}</p>
                                    <div id="timer" class="d-flex justify-content-center">
                                        <div id="days"
                                            class="align-items-center flex-column d-flex justify-content-center">
                                            {{days}} <span>{{resource.days}}</span></div>
                                        <div id="hours"
                                            class="align-items-center flex-column d-flex justify-content-center">
                                            {{hours}} <span>{{resource.hours}}</span></div>
                                        <div id="minutes"
                                            class="align-items-center flex-column d-flex justify-content-center">
                                            {{minutes}} <span>{{resource.minutes}}</span></div>
                                        <div id="seconds"
                                            class="align-items-center flex-column d-flex justify-content-center">
                                            {{seconds}} <span>{{resource.seconds}}</span></div>
                                    </div>
                                    <br>
                                </div>
                            </div>
                            <div class="widget widget_about_store"
                                style="max-height: 600px; overflow-y: auto; padding-top: 0 !important;"
                                *ngIf="stores.length">
                                <h3
                                    style="font-size: 20px; background-color: white; position: sticky; top: 0; padding-top: 20px;">
                                    {{resource.retail_stores}}</h3>
                                <!-- <div *ngFor="let store of stores" class="row" style="cursor: pointer;"
                                    (click)="backToStoreDeals(store.ownerId)"> -->
                                <!-- <div *ngFor="let store of stores; let i = index"
                                    class="row" style="cursor: pointer;"> -->
                                <div *ngFor="let store of stores; let i = index; trackBy: trackByStore" class="row"
                                    style="cursor: pointer;">
                                    <div class="col-3" style="text-align: center;">
                                        <i class='bx bxs-store' style="font-size: 72px; color: #a2a1a1;"></i>
                                        <p style="font-size: 12px; font-weight: 600;">
                                            {{ store.displayIndex }} </p>
                                        <!-- <p style="font-size: 12px;">{{store.distance.toFixed(0)}}</p> -->
                                        <!-- <p style="font-size: 12px;" *ngIf="store?.distance !== null && store?.distance !== undefined">
                                   {{ (+store.distance) | number:'1.0-0' }}</p> -->
                                    </div>
                                    <div class="col-9"
                                        style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                        <p style="font-size: 16px; color: black; font-weight: 600; margin: 0;">
                                            {{store.name}}
                                        </p>
                                        <p style="margin: 0;"><i class="bx bx-map"></i> <span>{{store.address}}</span>
                                        </p>
                                        <p style="margin: 0;">PinCode - {{store.postalCode}}</p>
                                        <div class="row" style="margin: 0; color: #666666;">
                                            <div class="col-5"
                                                style="padding: 0; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                                <i class="bx bx-user"></i> <span>{{store.primaryContact}} </span>
                                            </div>
                                            <div class="col-1" style="padding: 0;"></div>
                                            <div class="col-6"
                                                style="padding: 0; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                                                <i class="bx bx-phone-call"></i> <span> {{store.telephone}} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </section>

    </div>
</div>